// Central API configuration helper.
// Priority order for base URL:
// 1. Explicit override passed to function (options.baseUrl)
// 2. window.API_BASE_URL (can be set in index.html before bundle loads)
// 3. process.env.ATP_API_BASE (preferred new env variable)
//    (Legacy fallback: process.env.REACT_APP_API_BASE still honored if ATP_API_BASE absent)
// 4. Default fallback constant.
//
// To set per environment:
// - Local dev: add ATP_API_BASE=http://localhost:5000 to .env
// - Staging/Prod: set window.API_BASE_URL via a script tag in index.html or use env variable at build time.
const DEFAULT_API_BASE = 'https://magmatenniswebapi.azurewebsites.net';
//const DEFAULT_API_BASE = 'http://172.31.252.82:4260/';

export function getApiBase(explicit) {
  if (explicit) return sanitizeBase(explicit);
  // window may not exist in SSR
  const winBase = (typeof window !== 'undefined' && window.API_BASE_URL) ? window.API_BASE_URL : null;
  const envBase = typeof process !== 'undefined'
    ? (process.env.ATP_API_BASE || process.env.REACT_APP_API_BASE) // backward compatibility
    : null;
  return sanitizeBase(winBase || envBase || DEFAULT_API_BASE);
}

function sanitizeBase(url) {
  if (!url) return DEFAULT_API_BASE;
  // remove trailing slashes
  return String(url).trim().replace(/\/+$/, '');
}

// Helper to build an endpoint path with query object
export function buildEndpoint(base, path, query) {
  const url = new URL(path, base + '/');
  if (query && typeof query === 'object') {
    Object.entries(query).forEach(([k, v]) => {
      if (v !== undefined && v !== null) url.searchParams.append(k, v);
    });
  }
  return url.toString();
}

export const API_DEFAULTS = { DEFAULT_API_BASE };
